export default __webpack_public_path__ + "static/char-09-639c2d1f5bfc20b3ddbacb1a1c7b4fdf.gif";